import React, {useEffect, useState} from "react"

import {Card, CardBody, Container, Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTitle from "../../components/MetaTitle"
import classnames from "classnames"
import ProgressView from "../../components/ProgressView"
import {PageLoader} from "../../components/PageLoader"
import TMPButton from "../../components/TMPButton"
import DetailsComponent from "../../components/DetailsComponent"
import useSubscriptions from "../../hooks/useSubscriptions"

const styles = {
    tabStyle: {
        cursor: "pointer"
    }
}


const PackageDetail = ({match, location, ...rest}) => {
    const {id} = match.params
    const {findSubscription, subscription, isLoading, activateSubscription} = useSubscriptions()

    const [activeTab, setActiveTab] = useState(0)
    const toggle = tab => setActiveTab(tab)


    useEffect(() => {
        findSubscription(id)
    }, [])

    return (
        <React.Fragment>
            {subscription ?
                <div className="page-content">
                    <MetaTitle title={subscription.name}/>
                    <Container fluid={true}>
                        <Breadcrumbs title="Dashboard" breadcrumbItem={subscription.name} {...rest}/>

                        <Card>
                            <CardBody>

                                <div className={"mb-2 mt-2 d-flex justify-content-end"}>
                                    {isLoading ? <ProgressView/> :
                                        <TMPButton
                                            outline
                                            onClick={() => {
                                                activateSubscription(subscription.id, subscription?.status === 'active' ? 'inactive' : 'active')
                                            }}
                                        >
                                            {subscription?.status === 'active' ? "Disable" : "Activate"}
                                        </TMPButton>}
                                </div>

                                <Nav tabs>
                                    <NavItem>
                                        <NavLink
                                            style={styles.tabStyle}
                                            className={classnames({
                                                active: activeTab === 0,
                                            })}
                                            onClick={() => toggle(0)}
                                        >
                                            Details
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={styles.tabStyle}
                                            className={classnames({
                                                active: activeTab === 1,
                                            })}
                                            onClick={() => toggle(1)}
                                        >
                                            Businesses
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent activeTab={activeTab} className="p-3 text-muted">
                                    <TabPane tabId={0}>
                                        <DetailsComponent
                                            details={[
                                                {title: "Name", des: subscription.name},
                                                {title: "Code", des: subscription.code},
                                                {title: "Staff", des: subscription.staff},
                                                {title: "Price", des: subscription.price},
                                            ]}
                                        />
                                    </TabPane>
                                </TabContent>

                            </CardBody>
                        </Card>

                    </Container>
                </div>
                : <PageLoader/>
            }

        </React.Fragment>
    )
}

export default PackageDetail
